(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["treehood-back-bar"] && !Shopify.designMode) return;
  try {
    if (!window.thBackbarReady) {
    window.thBackbarReady = true;
    document.addEventListener('click', function(event) {
      var link = event.target.closest('[data-th-smart-back]');
      if (!link) return;

      var sameOrigin = false;
      try {
        sameOrigin = document.referrer && new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        sameOrigin = false;
      }

      if (!sameOrigin || window.history.length <= 1) return;

      event.preventDefault();
      window.history.back();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
